import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bool } from "prop-types";
import { Link } from "react-router-dom";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import Drawer from "pages/_components/Drawer/Drawer";
import { actions as debinActions } from "reducers/debin";
import { debinOptions } from "util/debin";
import moment from "moment";
import { getLimitDate } from "util/date";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import TitleColumns from "./components/TitleColumns";
import ReceivedDebinItem from "./components/ItemRow";
import EmitedSideBarForm from "../_components/SideBarForm";
import FilterTags from "../_components/FilterTags";

const EmitedDebin = ({ isDesktop }) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
    const { fetching, sentRequests, totalPages, pageNumber, filterRecurrencyList } = useSelector(
        (state) => state.debin,
    );
    const [debinPagination, setDebinPagination] = useState(pageNumber);
    const hasMoreData = pageNumber < totalPages;
    const dispatch = useDispatch();
    const row = isDesktop ? 1 : 3;

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };

    const fetchMoreTransactions = () => {
        setDebinPagination(pageNumber + 1);
        dispatch(debinActions.loadSentRequests({ ...filterRecurrencyList, pageNumber: debinPagination + 1 }));
    };

    useEffect(() => {
        const data = {
            dateFrom: getLimitDate(-7),
            dateTo: moment().toDate(),
            seller: "",
            status: "Todos",
            pageNumber: 1,
        };
        dispatch(debinActions.setRecurrencyDebinFilters({ ...data, pageNumber: 1 }));
        dispatch(debinActions.loadSentRequests({ ...data }));
    }, []);

    return (
        <div className="container">
            <FilterTags openSideBarFilters={openSideBarFilters} optiondebin={debinOptions[2]} isEmited />
            {sentRequests.debinList?.length ? (
                <>
                    <ProductList
                        fetchingWithPreviousData
                        fetching={fetching}
                        items={sentRequests.debinList || []}
                        noDataText="debin.emitted.no.results"
                        noFiltersDataText="debin.emitted.no.results"
                        renderItem={(item) => (
                            <GridTable.Container
                                rows={row}
                                key={`emited-debin-item-${item.id}`}
                                renderAs={Link}
                                to={`/debin/issued/detail/${item.id}`}>
                                <ReceivedDebinItem
                                    key={`transaction-${item.id}`}
                                    receibedDebin={item}
                                    setDrawer={setActionDrawer}
                                    isDesktop={isDesktop}
                                />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="debin-table emited">
                                <GridTable.Header>
                                    <GridTable.Container rows={row}>
                                        <TitleColumns />
                                    </GridTable.Container>
                                </GridTable.Header>
                                <GridTable.Body>
                                    {listItem}
                                    {hasMoreData && (
                                        <Button
                                            bsStyle="link"
                                            onClick={() => fetchMoreTransactions()}
                                            image="images/figma/icon/arrow.svg"
                                            label="global.showMore"
                                        />
                                    )}
                                </GridTable.Body>
                            </GridTable>
                        )}
                    </ProductList>
                </>
            ) : (
                <EmptyScreenAlert message="debin.service.empty.sent" />
            )}
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <EmitedSideBarForm closeSidebar={setOpenSidebar} isEmited />
            </Drawer>
            <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                {actionDrawer.contentDrawer}
            </Drawer>
        </div>
    );
};

EmitedDebin.propTypes = {
    isDesktop: bool.isRequired,
};

export default EmitedDebin;
